import types from './types'
import { Employee } from '@reaction-club-types/core'

export default {
  setEmployees: (employees: Employee[]) => ({ type: types.SET_EMPLOYEES, payload: { employees } }),
}
